const translations = {
  en: {
    langugage: "Language",
    en: "English",
    sp: "Spanish",
    check_error: "Invite Code is invalid or have expired.",
    generate_error:
      "Encountered an issue on generating Assessment. Please contact your administrator.",
    completed:
      "Your assessment has been completed. Please contact your administrator!",
    loader: "Loading...",
    expired: "Time Expired",
    examination_expired:
      "This examination has expired. Please contact the test administrator.",
    required: "Please complete all fields before continuing.",
    valid_email: "Please enter a valid email!",
    agree_check:
      "Please check agree to the terms and conditions to continue.\n\nIf you do not agree, please close your browser and contact your test Administrator.",
    agree_id_verification_and_consent:
      "Please check agree to ID verification consent to continue.\nIf you do not agree, please close your browser and contact your test Administrator.",
    tester_error:
      "Something went wrong during candidate creation. Please contact administrator!",
    alert_error: "Something went wrong. Please contact administrator!",
    ready: "You're ready to test!",
    code: "Invitation Code:",
    firstname: "First Name",
    lastname: "Last Name",
    email: "Email Address",
    job: "What job are you applying for?",
    agree: "I agree to the",
    terms: "terms and conditions",
    id_verification_and_consent: "ID Verification Consent",
    cont: "CONTINUE",
    mterms: "Terms and Conditions",
    m_id_verification_and_consent: "ID Consent",
    txt_id_verification:
      "You have been invited to complete one or more online assessments. To maintain the integrity of this online assessment process, we use an automated ID verification process and adhere to strict confidentiality and privacy requirements with respect to your data. The automated ID verification process utilizes your computer/phone camera to monitor your progress throughout the testing session. The ID verification tool will take a photo of your face and legal identification card (e.g., license, student ID, permanent resident card, military id) before you start the test. Your computer/phone camera will also be used to take various pictures while you are completing the assessment(s). Access to your camera will cease once you complete your assessment and close your browser. These image captures will be made available to the test administrator and will be used to verify the integrity of the testing session. Upon completion of the evaluation process these images will be permanently deleted.",
    txt_id_consent:
      "I acknowledge that my computer/phone screen may be used to take my picture at the beginning and throughout the examination process to ensure the integrity of the assessment(s). I agree that no one other than myself will appear on my computer/phone screen. I understand that such data will be retrieved and analyzed by the organization administering the assessment(s) to ensure the integrity of the assessment process.",
    txt_terms:
      "The following are questions intended to assess various aspects of your knowledge, skill, and/or job-relevant behaviors. By completing this assessment you agree to answer each question truthfully. Truthful responses lead to a more accurate representation of your skills and dispositions and therefore result in a better fit between you and the company. Less than truthful responses may serve to lower your scores. Therefore it is strongly recommended that you answer truthfully.",
    txt_terms2:
      "You should also know that we are committed to providing an inclusive and accessible recruitment process for all candidates. If you require any reasonable accommodations to participate in the testing process, you agree that you will let the test administrator know before continuing with this test.",
    close: "CLOSE",
    id_capture_header: "ID Capture",
    id_capture_instructions:
      "You must be able to use a webcam for this test. If you do not see your image in the box below, please enable webcam in your settings. If you are unable to use the webcam, please contact your test administrator.",
    id_capture_instructions_2:
      "We need a clear photo of your current government issued photo I.D. Align your I.D. within the yellow frame.",
    retake_photo: "RETAKE PHOTO",
    capture: "CAPTURE PHOTO",
    diff_email: "Email is not the same!",
    enter_code: "Please Enter invite code:",
    submit: "Submit",
    ass_url: "Assessment URL",
    txt_email:
      "Before we begin please enter your email address in the box below. We capture this to allow you to reenter the test and pick back up where you left off in the event you lose internet connectivity. If you are taking a timed test and lose internet connection, please contact your test administrator. The timer on timed tests will continue to run when logged out.",
    next: "Next",
    saving: "Saving...",
    session_details: "Session Details",
    session_p1: "Your session includes the following:",
    session_before:
      "Before taking the test, please make sure you have a stable internet connection.",
    session_p2:
      "Once you start your session, do not close your browser or navigate to other pages until you are finished.",
    session_p3:
      "You will be presented with one or more sets of instructions and assessments so please continue until you see the SUCCESS screen.",
    session_est: "Estimated time to complete the assessment(s):",
    session_est_time_limit: "%{timed} minutes",
    session_one_minute_limit: "1 minute",
    start: "START",
    "Job Fit Assessment": "Job Fit Assesment",
    "Athlete Behaviors Assessment": "Athlete Behaviors Assessment",
    instruct: "Instructions",
    instruct_lead:
      "Please make sure you are in a quiet place free from distractions.",
    instruct_sub_lead_practice_test_typing:
      "Please do not take this test on a mobile device. This test measures words per minutes typed and your accuracy rate.  Therefore, it is strongly recommended that you use a full-size keyboard when completing this test.",
    instruct_sub_lead_practice_test_data_entry:
      "Please do not take this test on a mobile device. This test measures data entry speed and accuracy. Therefore, it is strongly recommended that you use a full-size keyboard when completing this test.",
    instruct_start: "Click START to begin.",
    exit_session: "Exit Session",
    question: "Question %{curr}/%{total}",
    question_sub:
      "Select the option below that conforms to the following rules.",
    prev: "Previous",
    "Good Luck!!!": "Good Luck!!!",
    success: "Success!",
    comp_test: "You have successfully completed your testing session.",
    comp_close: "CLOSE THIS WINDOW",
    comp_close_text: "You may now close this window.",
    exam_completion_processing: "PROCESSING...",
    exam_completion_processing_text:
      "Please do not close this window until processing has completed.",
    timer_exp: "Your time for this assessment has expired.",
    timer_sec: "Seconds",
    timer_timed: "Timed Section",
    time_exp: "Session Expired!",
    time_p1:
      "Your session already expired. Click CONTINUE to move to the next qustion.",
    demo_info: "Demographic Information",
    demo_p1:
      "Completion of the information that follows is completely voluntary. This information is being collected for research purposes only. This data is used to ensure our evaluation process continues to be fair and free from bias. There will be no impact on your application if you choose not to answer any of these questions. If you elect not to answer the questions, simply select the “Prefer not to Answer” response option. Thank you!",
    demo_req: "`Please select %{demo}",
    h_email: "Enter Email",
    h_reemail: "Re-Enter Email",
    h_invite: "Invite Code",
    "Please fill out this field.": "Please fill out this field.",
    logo_client: "Client-logo",
    logo_partner: "Distributor-logo",
    logo_psy: "Psymetrics-logo",
    back: "Back",
    select_demo: "Please select %{field}",
    sport: "Sport",
    position: "Position",
    level: "Level",
    gender: "Gender",
    sport_info: "Sport-Specific Demographic Information",
    sport_intro:
      "Please complete the following information to ensure your score will be compared to the appropriate athlete population.",
    select: "Select",
    imgComp_more: "Please select one or more answer.",
    imgComp_not:
      "Select one or more pictures below that DO NOT match the top, highlighted image.",
    imgComp_select: "Submit Selected Choice(s)",
    twoComp_diff: "Are the two sets of information the same or different?",
    "Doing Great!!!": "Doing Great!!!",
    "Halfway There!!!": "Halfway There!!!",
    "Almost Done!!!": "Almost Done!!!",
    "Congratulations!!!": "Congratulations!!!",
    whoops: "Whoops!",
    no_internet_err:
      "Slow or no internet connection. Please check your internet settings.",
    job_application: "Job Application",
    job_application_instruction: "Job Application Instructions",
    job_application_instruction_part_one:
      "The following screens include a job application form for you to complete.",
    job_application_instruction_part_two:
      "Before you start filling out the form, please make sure you have all your work and education information and documents available to reference, if needed. As you are aware, false information can jeopardize your chances of getting hired.",
    job_application_instruction_part_three:
      "Please take your time and provide all the information that reflects your full list of skills, experience, and professionalism, even if you aren't sure if it's relevant to this position.",
    job_application_estimated_time:
      "Estimated time to complete the job application:  10-15 minutes",
    save_and_continue: "SAVE AND CONTINUE",
    section_timer_exp:
      "Your time has expired for this section. Please click Continue to begin the next section.",
    practice_typing_test_timer_exp:
      "Your time is up. Please click Continue to begin the actual typing test.",
    practice_data_entry_test_timer_exp:
      "Your time is up. Please click Continue to begin the actual data entry test.",
    typing_test_timer_exp: "Your time is up. Please click Continue to proceed.",
    open_question: "Job Related Questions",
    open_question_eta:
      "The estimated time to complete the question section will vary depending on the number of questions presented.",
    open_question_instruction: "Instructions",
    open_question_instruction_part_one:
      "The following screens include one or more job-related questions.",
    open_question_instruction_part_two:
      "Questions may be either multiple choice, open ended, or both. Please answer each question to the best of your ability. For open ended questions, try to be as thorough as possible in your response.",
    open_question_instruction_part_three:
      "Please use correct spelling, grammar and punctuation. Once you answer a question, you will only be able to go back one questions if needed.",
    notice: "Important Notice",
    notice_message:
      "When you begin the following test session, please do not click on or open tabs, email or text notifications, or browsers outside of the test window. Doing so may invalidate the test results. All clicks outside the test window are recorded and are visible by the test administrator.  If you need to turn off notifications to avoid distractions, do so now.",
    switch_notice:
      "You have switched away from the testing window. Please return to the test to continue. Repeated switching may be flagged as suspicious activity and will invalidate your test results.",
    time_left: "You have 1 minute left.",
  },
  sp: {
    langugage: "Idioma",
    en: "Inglés",
    sp: "Español",
    check_error: "El código de invitación no es válido o ha caducado.",
    generate_error:
      "Se encontró un problema al generar la evaluación. Comuníquese con su administrador.",
    completed:
      "Su evaluación ha sido completada. ¡Por favor contacte a su administrador!",
    loader: "Cargando...",
    expired: "El Tiempo Expiro",
    examination_expired:
      "Este examen ha caducado. Póngase en contacto con el administrador de la prueba.",
    required: "Por favor complete todos los campos antes de continuar.",
    valid_email:
      "¡Por favor introduzca una dirección de correo electrónico válida!",
    agree_check:
      "Marque la casilla confirmando que está de acuerdo con los términos y condiciones para continuar.",
    agree_id_verification_and_consent:
      "Marque Acepto el consentimiento de verificación de identidad para continuar.\nSi no está de acuerdo, cierre su navegador y comuníquese con el administrador de su prueba.",
    tester_error:
      "Algo salió mal durante la creación de candidato. ¡Por favor, póngase en contacto con el administrador!",
    alert_error:
      "Algo salió mal. ¡Por favor, póngase en contacto con el administrador!",
    ready: "¡Está listo para la prueba!",
    code: "Código de Invitación:",
    firstname: "Nombre",
    lastname: "Apellido",
    email: "Dirección de correo electrónico",
    job: "¿Cuál es el puesto para el que solicita?",
    agree: "Acepto los ",
    terms: "términos y condiciones",
    id_verification_and_consent: "Consentimiento de Verificación de Identidad",
    m_id_verification_and_consent: "Consentimiento de Identificación",
    txt_id_verification:
      "Ha sido invitado a completar una o más evaluaciones en línea. Para mantener la integridad de este proceso de evaluación en línea, utilizamos un proceso de verificación de identidad automatizado y nos adherimos a estrictos requisitos de confidencialidad y privacidad con respecto a sus datos. El proceso de verificación de identidad automatizado utiliza la cámara de su computadora/teléfono para monitorear su progreso a lo largo de la sesión de prueba. La herramienta de verificación de identidad tomará una foto de su rostro y de su tarjeta de identificación legal (por ejemplo, licencia de conducir, identificación de estudiante, tarjeta de residente permanente, identificación militar) antes de comenzar la prueba. La cámara de su computadora/teléfono también se usará para tomar varias fotografías mientras completa la(s) evaluación(es). El acceso a su cámara cesará una vez que complete la evaluación y cierre el navegador. Estas capturas de imágenes estarán disponibles para el administrador de la prueba y se utilizarán para verificar la integridad de la sesión de prueba. Una vez finalizado el proceso de evaluación, estas imágenes se eliminarán de forma permanente.",
    txt_id_consent:
      "Reconozco que se puede usar la pantalla de mi computadora/teléfono para tomarme una fotografía al comienzo y durante todo el proceso de examen para garantizar la integridad de la(s) evaluación(es). Acepto que nadie más que yo mismo aparecerá en la pantalla de mi computadora/teléfono. Entiendo que dichos datos serán recuperados y analizados por la organización que administra la(s) evaluación(es) para garantizar la integridad del proceso de evaluación.",
    cont: "CONTINUAR",
    mterms: "Términos y Condiciones",
    txt_terms:
      "Las siguientes son preguntas destinadas a evaluar varios aspectos de su conocimiento, habilidad y/o comportamientos relevantes para el trabajo. Al completar esta evaluación, acepta responder cada pregunta con la verdad. Las respuestas veraces conducen a una representación más precisa de sus habilidades y disposiciones y, por lo tanto, resultará en un mejor ajuste entre usted y la empresa. Las respuestas menos que veraces pueden servir para bajar sus puntajes. Por lo tanto, se recomienda encarecidamente que responda con la verdad ",
    txt_terms2:
      "También debe saber que estamos comprometidos a proporcionar un proceso de evaluación inclusivo y accesible para todos los candidatos. Si necesita algún ajuste razonable para completar esta evaluación, usted acepta informar al administrador del examen antes de continuar con esta prueba.",
    id_capture_header: "Captura de Identidad",
    id_capture_instructions:
      "Debe poder usar una cámara web para esta prueba. Habilite la cámara web en su configuración. Si no puede usar la cámara web, comuníquese con el administrador de la prueba.",
    id_capture_instructions_2:
      "Necesitamos una foto actual emitida por el gobierno. Alinee su foto de Identificación dentro del marco amarillo.",
    retake_photo: "VOLVER A TOMAR FOTO",
    capture: "CAPTURAR FOTO",
    close: "CERRAR",
    diff_email: "¡El correo electrónico no es lo mismo!",
    enter_code: "Ingrese el código de invitación:",
    submit: "Someter",
    ass_url: "URL de Evaluación",
    txt_email:
      "Antes de comenzar, ingrese su dirección de correo electrónico en el cuadro a continuación. Capturamos esto para permitirle volver a ingresar a la prueba y continuar donde la dejó en caso de que pierda la conexión a Internet. Si está tomando una prueba cronometrada y pierde Internet conexión, comuníquese con el administrador de la prueba. El temporizador de las pruebas cronometradas continuará ejecutándose cuando cierre la sesión.",
    next: "Próximo",
    saving: "Ahorro...",
    session_details: "Detalles de la Sesión",
    session_p1: "Su sesión incluye la/s siguiente/s:",
    session_before:
      "Antes de realizar la prueba, por favor asegúrate de tener una conexión a internet estable.",
    session_p2:
      "Una vez que inicies tu sesión, no cierres el navegador ni navegues a otras páginas hasta que hayas terminado.",
    session_p3:
      "Se te presentarán una o más series de instrucciones y evaluaciones, así que continúa hasta que veas la pantalla de ÉXITO.",
    session_est: "Tiempo estimado para completar la(s) evaluación(es):",
    session_est_time_limit: "%{timed} minutos",
    session_one_minute_limit: "1 minuto",
    start: "COMENZAR",
    "Job Fit Assessment": "Evaluación de Apto para el Trabajo",
    "Athlete Behaviors Assessment": "Evaluación de Comportamientos de Atletas",
    instruct: "Instrucciones",
    instruct_lead:
      "Por favor, asegúrese de estar en un lugar tranquilo y libre de distracciones.",
    instruct_sub_lead_practice_test_typing:
      "Please do not take this test on a mobile device. This test measures words per minutes typed and your accuracy rate.  Therefore, it is strongly recommended that you use a full-size keyboard when completing this test.",
    instruct_sub_lead_practice_test_data_entry:
      "Please do not take this test on a mobile device. This test measures data entry speed and accuracy. Therefore, it is strongly recommended that you use a full-size keyboard when completing this test.",
    instruct_start: "Haz clic en COMENZAR para iniciar.",
    exit_session: "Salir de la Sesión",
    question: "Pregunta %{curr}/%{total}",
    question_sub:
      "Seleccionar la opción a continuación que cumple con las siguientes reglas.",
    prev: "Anterior",
    "Good Luck!!!": "¡Buena Suerte!",
    success: "¡Éxito!",
    comp_test: "Ha completado con éxito su sesión de prueba.",
    comp_close: "CERRAR ESTA VENTANA",
    comp_close_text: "Ahora puedes cerrar la ventana.",
    exam_completion_processing: "PROCESANDO...",
    exam_completion_processing_text:
      "Por favor no cierre esta ventana hasta que se haya completado el procesamiento de datos.",
    timer_exp: "Su tiempo para esta evaluación ha caducado.",
    timer_sec: "Segundos",
    timer_timed: "Sección de Tiempo",
    time_exp: "¡Sesión Expiró!",
    time_p1:
      "Tu sesión ya venció. Haz clic en CONTINUAR para pasar a la siguiente pregunta.",
    demo_info: "Información demográfica",
    demo_p1:
      'Completar la información que sigue es completamente voluntaria. Esta información se recopila únicamente con fines de investigación. Estos datos se utilizan para garantizar que nuestro proceso de evaluación continúe siendo justo y libre de prejuicios. No habrá ningún impacto en su solicitud de trabajo si elige no responder a ninguna de estas preguntas. Si elige no responder las preguntas, simplemente seleccione "Prefiero no responder" en la lista de opciones. ¡Gracias!',
    demo_req: "Por favor seleccione %{demo}",
    h_email: "Ingrese Correo Electrónico",
    h_reemail: "Volver A Introducir Correo Electrónico",
    h_invite: "Codigo de Invitacion",
    "Please fill out this field.": "Por favor rellene este campo.",
    logo_client: "Cliente-Logotipo",
    logo_partner: "Distribuidor-Logotipo",
    logo_psy: "Psymetrics-Logotipo",
    back: "Atras",
    select_demo: "Por favor, seleccione %{field}",
    sport: "Deporte",
    position: "Posición",
    level: "Nivel",
    gender: "Género",
    sport_info: "Deporte específico Información demográfica",
    sport_intro:
      "Por favor complete la siguiente información para asegurar que su resultado pueda ser comparado con la correspondiente población atleta.",
    select: "Seleccionar",
    imgComp_more: "Seleccione una o más respuestas.",
    imgComp_not:
      "Seleccione una o más imágenes a continuación que NO coincidan con el imagen resaltada en la parte superior.",
    imgComp_select: "Enviar la(s) opción(es) seleccionada(s)",
    twoComp_diff: "Ambos juegos de información, ¿son iguales o diferentes?",
    "Doing Great!!!": "Haciendo genial!!!",
    "Halfway There!!!": "A mitad de camino!!!",
    "Almost Done!!!": "Casi hecho!!!",
    "Congratulations!!!": "Felicidades!!!",
    whoops: "¡Alerta!",
    no_internet_err:
      "Su conexión a internet es muy lenta o se ha desconectado. Por favor verifique que su conexión a internet esté funcionando correctamente.",
    job_application: "Aplicacion de Trabajo",
    job_application_instruction: "Instrucciones de solicitud de empleo",
    job_application_instruction_part_one:
      "Las siguientes pantallas incluyen un formulario de solicitud de empleo que debe completar.",
    job_application_instruction_part_two:
      "Antes de comenzar a completar el formulario, asegúrese de tener toda la información y los documentos de su trabajo y educación disponibles para consultarlos, si es necesario. Como sabe, la información falsa puede poner en peligro sus posibilidades de ser contratado.",
    job_application_instruction_part_three:
      "Tómese su tiempo y proporcione toda la información que refleje su lista completa de habilidades, experiencia y profesionalismo, incluso si no está seguro de si es relevante para este puesto.",
    job_application_estimated_time:
      "Tiempo estimado para completar la solicitud de empleo: 10-15 minutos",
    save_and_continue: "Guardar y Continuar",
    section_timer_exp:
      "Your time has expired for this section. Please click Continue to begin the next section.",
    practice_typing_test_timer_exp:
      "Your time is up. Please click Continue to begin the actual typing test.",
    practice_data_entry_test_timer_exp:
      "Your time is up. Please click Continue to begin the actual data entry test.",
    typing_test_timer_exp: "Your time is up. Please click Continue to proceed.",
    open_question: "Preguntas Relacionadas Con El Trabajo",
    open_question_eta:
      "El tiempo estimado para completar la sección de preguntas variará según la cantidad de preguntas presentadas.",
    open_question_instruction: "Instrucciones",
    open_question_instruction_part_one:
      "Las pantallas siguientes incluyen una o más preguntas relacionadas con el trabajo.",
    open_question_instruction_part_two:
      "Las preguntas pueden ser de opción múltiple, abiertas o ambas. Por favor, responde cada pregunta de la mejor manera posible. Para las preguntas abiertas, trata de ser lo más detallado posible en tu respuesta.",
    open_question_instruction_part_three:
      "Utiliza la ortografía, gramática y puntuación correctas, por favor. Una vez que haya respondido a la pregunta, solamente podrá regresar a una pregunta, si lo necesita.",
    notice: "Aviso Importante",
    notice_message:
      "Cuando comience la siguiente sesión de prueba, por favor no haga clic en ni abra pestañas, notificaciones de correo electrónico o mensajes de texto, ni navegadores fuera de la ventana de la prueba. Hacerlo puede invalidar los resultados de la prueba. Todos los clics fuera de la ventana de la prueba se registran y son visibles para el administrador de la prueba. Si necesitas desactivar las notificaciones para evitar distracciones, hazlo ahora.",
    switch_notice:
      "Se ha desviado de la ventana de prueba. Por favor, regrese a la prueba para continuar. Cambios repetidos pueden ser señalados como actividad sospechosa y invalidarán sus resultados de la prueba.",
    time_left: "Te queda 1 minuto.",
  },
};

export default translations;
